import { AccordionDetails } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekAccordionDetails = styled(AccordionDetails)(({ theme }) => ({}));

export { PeekAccordionDetails, PeekAccordionDetails as default };
